import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Environment
import { environment } from './../../../environments/environment';

// Components
import { PqrComponent } from './pqr/pqr.component';

const routes: Routes = [
    {
        path: '',
        component: PqrComponent,
        data: {
            meta: {
                robots: environment.statusMetaGeneric
            }
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class PqrRoutingModule { }